import React from "react";
import "./index.css";

import {createSearchParams} from "react-router-dom";
import Sidebar from "../../../../components/Sidebar";
import TableHeader from "../../../../components/TableHeader";
import PageHeader from "../../../../components/PageHeader";
import moment from "moment";
import Pagination from "../../../../components/Pagination";
import LinkPlus from "../../../../components/Link/LinkPlus";
import {getSchoolYear} from "../../../../utils/authority";
import vi from "date-fns/locale/vi";
import DatePicker, {registerLocale} from "react-datepicker";
import ModalDeleteService from "./modalDeleteService";
import ServiceOtherController from "../../../../services/system/service-other/service-other-controller";
import GradeManager, {GRADE_ALL} from "../../../../components/Grade";
import ServiceOtherRegisterController
    from "../../../../services/system/service-other-register/service-other-register-controller";
registerLocale("vi", vi);

class RegisterServiceManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            yearId: parseInt(getSchoolYear()),
            sort: 'DESC',
            pageNumber: 0,
            pageSize: 10,
            totalItem: 0,
            listData: [],

            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Tên dịch vụ",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "tax",
                    name: "Đối tượng áp dụng",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "endDate",
                    name: "Ngày hết hạn",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "state",
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "",
                    name: "Thao tác",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    componentWillMount() {
        this.getListService()
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListService();
            }
        );
    };
    getListService() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            name: this.state.name,
            state: this.state.state,
            pageNumber: 0,
            pageSize: 20,
            sort: "created_at desc"
        };
        ServiceOtherController.list(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
            });
        })
    }
    onhandleSearch() {
        this.getListService()
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "ACTIVE",
                "name": "Hoạt động"
            },
            {
                "id": "INACTIVE",
                "name": "Khóa"
            }
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    getNameGrade(gradeId){
        for (let i=0; i<GRADE_ALL.length; i++){
            if (GRADE_ALL[i].id === gradeId){
                return GRADE_ALL[i].name
            }
        }
        return ""
    }
    render() {
        let { listData, header} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="register-service" parentClass="service-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Quản lý đăng ký dịch vụ"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Tên Dịch vụ</label>
                                                <input
                                                    placeholder="Nhập tên dịch vụ"
                                                    name="name"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.name}
                                                    maxLength={50}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.onhandleSearch()
                                                        }
                                                    }}
                                                    onChange={val =>
                                                        this.setState({name: val.target.value.trim()})
                                                    }
                                                />
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-6 p-0 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Trạng thái</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.state}
                                                    onChange={(e) => {
                                                        this.state.state = e.target.value;
                                                        this.setState({
                                                            state: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="">Tất cả</option>
                                                    {this.renderStatus()}
                                                </select>
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex" style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}>
                                                <button
                                                    style={{height: 35}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => this.onhandleSearch()}
                                                >
                                                    Tìm kiếm
                                                </button>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "left"
                                                 }}>
                                                <label className="label-item col-12"><b>Lưu ý:</b> Dịch vụ chỉ có thể xóa khi chưa có học sinh nào đăng ký</label>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {" "}
                                                                {this.state.pageNumber * this.state.pageSize +
                                                                index +
                                                                1}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.name}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.typeObject == "ALL"?"Toàn trường": row.typeObject == "GRADE"?this.getNameGrade(row.valueObject):"Lớp "+row.valueObject}
                                                            </td>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {row.expiredDay ? moment(row.expiredDay).format('DD-MM-YYYY') : 'Chưa có dữ liệu'}
                                                            </td>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {row.state=="ACTIVE"?<span className="badge badge-success" style={{color: "white"}}>Hoạt động</span>:<span className="badge badge-danger" style={{color: "white"}}>Khóa</span>}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                <LinkPlus
                                                                    style={{color: '#000'}}
                                                                    to={{
                                                                        pathname: "/ad-sas-school/chi-tiet-dang-ky-dich-vu",
                                                                        search: createSearchParams({
                                                                            id: `${row.id}`
                                                                        }).toString(),
                                                                        state: {
                                                                            fromDashboard: true,
                                                                            id: row.id
                                                                        }
                                                                    }}
                                                                >
                                                                    <button className="btn btn-action p-2"
                                                                            title='Sửa'
                                                                            style={{cursor: 'pointer'}}
                                                                    >
                                                                        <i className="ti-pencil-alt"/>
                                                                    </button>
                                                                </LinkPlus>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalDeleteService
                    show={this.state.showModalDelete}
                    onHide={() => this.setState({showModalDelete: false})}
                    onRefresh={() => this.onhandleSearch()}
                    id={this.state.itemSelected}
                />
            </div>
        );
    }
}

export default RegisterServiceManagement;
